import React, { useState, useRef, useEffect } from 'react'
import { Table, Spin, Avatar, Button, Card } from 'antd'
import { useNavigate, useLocation } from 'react-router'
import { useSelector } from 'react-redux'

import Layout from '../components/layout/Layout'
import axiosInstance from '../utils/axiosInstance'

function Metrics() {
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState(null)
  const [dataTwo, setDataTwo] = useState(null)
  const userType = useSelector((state) => state.auth.user.type)

  const getData = async () => {
    try {
      setLoading(true)

      const response = await axiosInstance.get(`/api/v1/metrics/checkGoogleBucketSize`)

      setData(response.data)
      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  // for total number of completed activities and their points
  const getDataTwo = async () => {
    try {
      setLoading(true)

      const response = await axiosInstance.get(`/api/v1/metrics/totalActivitiesAndPoints`)

      setDataTwo(response.data)
      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  const makeBackup = async () => {
    try {
      setLoading(true)
      const response = await axiosInstance.post(`/api/v1/admin/downloadDbv3`, { s: 'onlyweKnow.2025' })
      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  useEffect(() => {
    // getData()
  }, [])

  return (
    <Layout>
      <div style={{ padding: '20px' }}>
        <div style={{ padding: '24px' }}>
          <div style={{ marginBottom: '32px' }}>
            <h2
              style={{
                fontSize: '24px',
                fontWeight: '600',
                marginBottom: '8px',
                color: '#1a1a1a',
              }}
            >
              Metrics Dashboard
            </h2>
            <p
              style={{
                color: '#666',
                fontSize: '14px',
                margin: 0,
              }}
            >
              Monitor and analyze your app's performance
            </p>
          </div>

          {loading && (
            <div style={{ marginBottom: '24px' }}>
              <Spin />
            </div>
          )}

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
              gap: '16px',
            }}
          >
            {[
              { title: 'Summary', subtitle: 'Overview & key metrics', url: '/metrics/summarypage', icon: '📊' },
              { title: 'Activities', subtitle: 'App activity tracking', url: '/metrics/activitiesPage', icon: '📈' },
              { title: 'Member Activities', subtitle: 'User engagement data', url: '/metrics/memberActivities', icon: '👥' },
              { title: 'Prove It', subtitle: 'Verification metrics', url: '/metrics/proveIt', icon: '✓' },
              { title: 'Focus Areas', subtitle: 'Priority tracking', url: '/metrics/focusAreasPage', icon: '🎯' },
              { title: 'Engagement', subtitle: 'User interaction stats', url: '/metrics/engagementPage', icon: '💬' },
              { title: 'User Data', subtitle: 'Member information', url: '/metrics/userData', icon: '📋' },
              { title: 'Leadership Track', subtitle: 'Leader performance', url: '/metrics/leadershipTrack', icon: '👑' },
              { title: "Leader's Stacks", subtitle: 'Stack analytics', url: '/metrics/userStacks', icon: '📚' },
              { title: 'Growth Profile', subtitle: 'View leaders growth', url: '/metrics/growthProfile', icon: '🌱' },
            ].map((metric, index) => (
              <a key={index} href={metric.url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                <Card
                  hoverable
                  style={{
                    height: '100%',
                    borderRadius: '12px',
                    border: '1px solid #f0f0f0',
                    transition: 'all 0.3s ease',
                  }}
                  bodyStyle={{ padding: '20px' }}
                >
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <div style={{ fontSize: '24px', marginBottom: '4px' }}>{metric.icon}</div>
                    <h3
                      style={{
                        margin: 0,
                        fontSize: '16px',
                        fontWeight: '600',
                        color: '#1a1a1a',
                      }}
                    >
                      {metric.title}
                    </h3>
                    <p
                      style={{
                        margin: 0,
                        fontSize: '13px',
                        color: '#666',
                        lineHeight: '1.4',
                      }}
                    >
                      {metric.subtitle}
                    </p>
                  </div>
                </Card>
              </a>
            ))}
          </div>
        </div>

        {userType == 'super-admin' && (
          <div>
            <hr />
            <Button type="default" style={{ cursor: 'pointer' }} onClick={getDataTwo} loading={loading}>
              Get total activities
            </Button>
            <p>& their points (All time)</p>
            {dataTwo && (
              <p>
                Total completed activites {dataTwo?.totalCompletedEvents} for {dataTwo?.totalPoints} points.
              </p>
            )}
            <hr />
            {loading ? (
              <div>
                <p>Please wait this may need sometime, depends on size of bucket and google response.</p>
              </div>
            ) : (
              <>
                <p style={{ fontSize: '1rem' }}>Result {data?.sizeString}</p>
                <Button type="default" style={{ cursor: 'pointer' }} onClick={getData}>
                  Get bucket size
                </Button>
                <p style={{ color: 'red' }}>
                  Increased bucket size will cost more money each month, but it also depends on various things such as number of operations at bucket, trash of bucket etc. Please
                  contact admin for proper billing each month.
                </p>
              </>
            )}
            <hr />
            <Button type="default" style={{ cursor: 'pointer' }} onClick={makeBackup}>
              Make backup
            </Button>
            <p>This will help to keep backup of database at storage server. Try to do it atleast once or few times per day.</p>
          </div>
        )}
      </div>
    </Layout>
  )
}

export default Metrics
